export default {
  domain: 'zwangerenportaal.nl'
}
